// extracted by mini-css-extract-plugin
export default {"caseDetailContainer":"caseDetail_caseDetailContainer__z6U5D","caseDetail":"caseDetail_caseDetail__275YX","error":"caseDetail_error__wSy2F"};